import './SearchPagination.svelte.css';
/* src/components/searchResult/SearchPagination.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_bidirectional_transition,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	safe_not_equal,
	set_data,
	set_store_value,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import { fade } from '../../../_snowpack/pkg/svelte/transition.js';
import { getSearchResult } from '../../stores/libREST.js';

import {
	inputValues,
	setCurrentParams,
	currentParams,
	setURLParams
} from '../../stores/storeInputOptions.js';

import {
	searchResult,
	isLoading,
	sitePrefix
} from '../../stores/storeSearchResult.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

// (27:0) {#if $searchResult && $searchResult.page}
function create_if_block(ctx) {
	let div;
	let p;
	let span;
	let t0_value = /*$searchResult*/ ctx[0].page.qty + "";
	let t0;
	let t1;
	let t2;
	let t3_value = /*$searchResult*/ ctx[0].page.start + "";
	let t3;
	let t4;
	let t5_value = /*$searchResult*/ ctx[0].page.end + "";
	let t5;
	let t6;
	let t7;
	let div_transition;
	let current;
	let if_block = 1 < /*$searchResult*/ ctx[0].page.page.length && create_if_block_1(ctx);

	return {
		c() {
			div = element("div");
			p = element("p");
			span = element("span");
			t0 = text(t0_value);
			t1 = space();
			t2 = text("件（ ");
			t3 = text(t3_value);
			t4 = text(" ～ ");
			t5 = text(t5_value);
			t6 = text(" 件表示 ）");
			t7 = space();
			if (if_block) if_block.c();
			attr(span, "class", "svelte-e74mz9");
			attr(p, "class", "svelte-e74mz9");
			attr(div, "class", "search-pagination svelte-e74mz9");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, p);
			append(p, span);
			append(span, t0);
			append(span, t1);
			append(p, t2);
			append(p, t3);
			append(p, t4);
			append(p, t5);
			append(p, t6);
			append(div, t7);
			if (if_block) if_block.m(div, null);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*$searchResult*/ 1) && t0_value !== (t0_value = /*$searchResult*/ ctx[0].page.qty + "")) set_data(t0, t0_value);
			if ((!current || dirty & /*$searchResult*/ 1) && t3_value !== (t3_value = /*$searchResult*/ ctx[0].page.start + "")) set_data(t3, t3_value);
			if ((!current || dirty & /*$searchResult*/ 1) && t5_value !== (t5_value = /*$searchResult*/ ctx[0].page.end + "")) set_data(t5, t5_value);

			if (1 < /*$searchResult*/ ctx[0].page.page.length) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fade, { delay: 250, duration: 300 }, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!div_transition) div_transition = create_bidirectional_transition(div, fade, { delay: 250, duration: 300 }, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
			if (detaching && div_transition) div_transition.end();
		}
	};
}

// (36:2) {#if 1 < $searchResult.page.page.length}
function create_if_block_1(ctx) {
	let t0;
	let t1;
	let if_block1_anchor;
	let if_block0 = /*$searchResult*/ ctx[0].page.prev && create_if_block_3(ctx);
	let each_value = /*$searchResult*/ ctx[0].page.page;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block1 = /*$searchResult*/ ctx[0].page.next && create_if_block_2(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t1 = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, t1, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
		},
		p(ctx, dirty) {
			if (/*$searchResult*/ ctx[0].page.prev) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*$searchResult, changePageNum*/ 3) {
				each_value = /*$searchResult*/ ctx[0].page.page;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(t1.parentNode, t1);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (/*$searchResult*/ ctx[0].page.next) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_2(ctx);
					if_block1.c();
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t1);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (37:3) {#if $searchResult.page.prev}
function create_if_block_3(ctx) {
	let button;
	let t;
	let button_value_value;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			t = text("前へ");
			attr(button, "class", "prev svelte-e74mz9");
			button.value = button_value_value = /*$searchResult*/ ctx[0].page.prev;
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, t);

			if (!mounted) {
				dispose = listen(button, "click", /*changePageNum*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*$searchResult*/ 1 && button_value_value !== (button_value_value = /*$searchResult*/ ctx[0].page.prev)) {
				button.value = button_value_value;
			}
		},
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

// (46:3) {#each $searchResult.page.page as num}
function create_each_block(ctx) {
	let button;
	let t_value = /*num*/ ctx[5] + "";
	let t;
	let button_value_value;
	let button_disabled_value;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			t = text(t_value);
			button.value = button_value_value = /*num*/ ctx[5];
			button.disabled = button_disabled_value = /*num*/ ctx[5] === /*$searchResult*/ ctx[0].page.current;
			attr(button, "class", "svelte-e74mz9");
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, t);

			if (!mounted) {
				dispose = listen(button, "click", /*changePageNum*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*$searchResult*/ 1 && t_value !== (t_value = /*num*/ ctx[5] + "")) set_data(t, t_value);

			if (dirty & /*$searchResult*/ 1 && button_value_value !== (button_value_value = /*num*/ ctx[5])) {
				button.value = button_value_value;
			}

			if (dirty & /*$searchResult*/ 1 && button_disabled_value !== (button_disabled_value = /*num*/ ctx[5] === /*$searchResult*/ ctx[0].page.current)) {
				button.disabled = button_disabled_value;
			}
		},
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

// (55:3) {#if $searchResult.page.next}
function create_if_block_2(ctx) {
	let button;
	let t;
	let button_value_value;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			t = text("次へ");
			attr(button, "class", "prev svelte-e74mz9");
			button.value = button_value_value = /*$searchResult*/ ctx[0].page.next;
		},
		m(target, anchor) {
			insert(target, button, anchor);
			append(button, t);

			if (!mounted) {
				dispose = listen(button, "click", /*changePageNum*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*$searchResult*/ 1 && button_value_value !== (button_value_value = /*$searchResult*/ ctx[0].page.next)) {
				button.value = button_value_value;
			}
		},
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*$searchResult*/ ctx[0] && /*$searchResult*/ ctx[0].page && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*$searchResult*/ ctx[0] && /*$searchResult*/ ctx[0].page) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*$searchResult*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $isLoading;
	let $currentParams;
	let $searchResult;
	let $inputValues;
	component_subscribe($$self, isLoading, $$value => $$invalidate(2, $isLoading = $$value));
	component_subscribe($$self, currentParams, $$value => $$invalidate(3, $currentParams = $$value));
	component_subscribe($$self, searchResult, $$value => $$invalidate(0, $searchResult = $$value));
	component_subscribe($$self, inputValues, $$value => $$invalidate(4, $inputValues = $$value));

	async function changePageNum(e) {
		if (!$currentParams) {
			await setCurrentParams($inputValues);
		}

		set_store_value(isLoading, $isLoading = true, $isLoading);
		set_store_value(currentParams, $currentParams['pid'] = e.target.value, $currentParams);
		set_store_value(searchResult, $searchResult = {}, $searchResult);
		set_store_value(searchResult, $searchResult = await getSearchResult($currentParams), $searchResult);
		setURLParams($currentParams);
		set_store_value(isLoading, $isLoading = false, $isLoading);
	}

	return [$searchResult, changePageNum];
}

class SearchPagination extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default SearchPagination;